import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Sayfa Bulunamadı (404)" description="Aradığınız sayfa bulunamadı." noindex />
      <section className="grain flex min-h-screen items-center justify-center bg-neutral-950 px-5">
        <div className="text-center">
          <p className="font-display text-7xl font-semibold text-gold-gradient sm:text-9xl">404</p>
          <h1 className="mt-4 font-display text-2xl font-medium text-white sm:text-3xl">Bu sayfa garajımızda yok</h1>
          <p className="mx-auto mt-3 max-w-md text-neutral-400">Aradığınız sayfa taşınmış veya hiç var olmamış olabilir. Sizi doğru yere yönlendirelim.</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center gap-2 rounded-xl bg-gold px-6 py-3.5 text-sm font-bold text-black hover:bg-gold-300 transition-colors">
              <Home className="h-4 w-4" /> Ana Sayfaya Dön
            </Link>
            <Link to="/hizmetler" className="inline-flex items-center gap-2 rounded-xl border border-white/15 px-6 py-3.5 text-sm font-semibold text-white hover:border-gold/40 transition-colors">
              <ArrowLeft className="h-4 w-4" /> Hizmetleri İncele
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
